import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

export default makeStyles((theme: Theme) => createStyles({
  container: {
    // height: 'calc(100vh - 24px)',
    height: '600px !important',
    overflow: 'hidden',
    [theme.breakpoints.up('lg')]: {
      position: 'sticky',
      top: 12,
    },
  },
  buttonAsk: {
    backgroundColor: theme.palette.primary.dark,
    borderRadius: 20,
    margin: '14px auto',
    minHeight: '44px'
  }
}), { name: 'DuvidasFrequentes' });
